import { AppConfig } from './app.config'
import { type ConfigInterface } from './config.interface'

export const appConfig = new AppConfig<ConfigInterface>()
